/* eslint-disable @typescript-eslint/no-explicit-any */
import { IconHot } from '@/components/Icon/IconHot'
import ImageOptimize from '@/components/ImageOptimize'
import { PageType } from '@/constants'
import { useNotification } from '@/containers'
import { useLocalStorage } from '@/hooks'
import HeaderSearch from '@/layouts/HeaderSearch'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import { type Promotion } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import { getProductHot } from '@/utils/endpoint'
import { getCookies } from 'cookies-next'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import Link from 'next/link'
import { useRouter } from 'next/router'

interface SearchResultPageProps {
  productHot: Promotion
}
const SearchResultPage = ({ productHot }: SearchResultPageProps) => {
  const router = useRouter()
  const { systemConfig } = useNotification()
  // const [suggestItems, setSuggestItems] = useState<Menu[]>([])
  const [searchHistory, setSearchHistory] = useLocalStorage<string[]>(
    'searchHistory',
    []
  )

  // useEffect(() => {
  //   getSearchSuggestMenu().then(res => {
  //     if (res) setSuggestItems(res)
  //   })
  // }, [])

  return (
    <Main
      meta={<Meta title={'Search'} description={'description'} />}
      pageLayout={PageType.SEARCH}
    >
      <HeaderSearch />
      <section className='searchHistory'>
        {searchHistory && searchHistory.length > 0 && (
          <div className='mt-6 px-2 mb-8'>
            <div className='flex justify-between'>
              <h3 className='font-bold text-titleDetail text-dark-800'>
                Lịch sử tìm kiếm
              </h3>
              <span
                onClick={() => setSearchHistory([])}
                className='text-primary-second text-promoTitle cursor-pointer font-normal'
              >
                Xóa lịch sử
              </span>
            </div>

            <div className='searchHistoryResult mt-[10px] flex flex-wrap gap-[8px]'>
              {searchHistory.map(e => (
                <span
                  onClick={() => {
                    return router.push(`/search-result?query=${e}`)
                  }}
                  key={`search-${e}`}
                  className='h-[36px] cursor-pointer hover:border-primary-base rounded-lg inline-flex w-max items-center px-[10px] border border-gray-100 bg-white'
                >
                  {e}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* <div className='suggestItems mt-7 px-2'>
          <div className='flex justify-between'>
            <h3 className='font-bold text-titleDetail text-dark-800'>
              Đề xuất tìm kiếm
            </h3>
          </div>
          <div className='searchHistoryResult mt-[10px] flex flex-wrap gap-[8px]'>
            {suggestItems.slice(0, 5).map((e, index) => (
              <span
                onClick={() => {
                  return router.push(
                    `/search-result?query=${getTranslate(e.name)}`
                  )
                }}
                key={`keyword-${index}`}
                className='h-[36px] hover:border-primary-base cursor-pointer rounded-lg inline-flex w-max items-center px-[10px] border border-gray-100 bg-white'
              >
                {getTranslate(e.name)}
              </span>
            ))}
          </div>
        </div> */}

        <div className='hotProducts bg-white min-h-[calc(100vh-60px)] rounded-t-lg overflow-hidden'>
          <div className='flex justify-between bg-gradient-to-b from-primary-base/30 to-transparent bg-no-repeat bg-[length:100%_34px] pt-3 px-2'>
            <h3 className='font-bold text-titleDetail flex items-center text-primary-base'>
              <IconHot className='inline-block mr-[12px]' />
              Gợi ý tìm kiếm
            </h3>
          </div>
          {productHot && productHot.products.length > 0 && (
            <div className='hotProductsResult mt-[10px] grid grid-cols-2 gap-y-3 gap-x-4 px-2'>
              {productHot.products.slice(0, 10).map(e => (
                <Link
                  key={e._id}
                  href={`/${getTranslate(e.slugs.value) + e.slugs.postfix}`}
                  className='hotProductDetail flex items-center'
                >
                  <ImageOptimize
                    alt={getTranslate(e.name)}
                    src={
                      e.thumbnail ||
                      systemConfig?.imagePlaceholder ||
                      process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
                      ''
                    }
                    width={100}
                    priority
                    height={100}
                    className='h-full max-h-[56px] w-[56px] object-cover'
                  />
                  <span className='text-dark-800 text-Prefix ml-[10px] line-clamp-3 overflow-hidden text-ellipsis'>
                    {getTranslate(e.name)}
                  </span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </Main>
  )
}

export default SearchResultPage

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res } = context

  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )

  const [productHot] = await Promise.all([getProductHot()])

  return {
    props: {
      productHot,
      language,
      messages,
      token: token || null,
    },
  }
}
